import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faPlus } from "@fortawesome/free-solid-svg-icons";

const DesktopNavigation = ({ categories, loadingCategories, isAuthenticated, location }) => {
	const [hoveredCategory, setHoveredCategory] = useState(null);

	const getLinkClass = (path) => {
		const isActive = location.pathname === path;
		return `flex items-center space-x-1 px-3 py-2 transition-all duration-300 border-b-2 font-medium tracking-wide ${isActive
			? "border-yellow-900 text-yellow-950 bg-yellow-900/5"
			: "border-transparent text-stone-600 hover:text-yellow-950 hover:bg-yellow-900/5 hover:border-yellow-900"
			}`;
	};

	return (
		<div className="hidden lg:block bg-[#FDFBF7] border-y border-stone-200 sticky top-0 z-40">
			<div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center py-1 px-6 text-[12px] md:text-[16px] tracking-widest">

				<div className="flex flex-wrap items-center gap-x-4 gap-y-1 py-2 flex-grow">
					{loadingCategories ? (
						<div className="flex space-x-6">
							{[...Array(8)].map((_, i) => (
								<div key={i} className="h-4 w-16 bg-stone-200 animate-pulse rounded-full"></div>
							))}
						</div>
					) : (
						categories.map((category) => (
							<div
								key={category.id}
								className="relative group"
								onMouseEnter={() => setHoveredCategory(category.id)}
								onMouseLeave={() => setHoveredCategory(null)}
							>
								<Link to={category.path} className={getLinkClass(category.path)}>
									<span>{category.name}</span>
									{category.subcategories?.length > 0 && (
										<FontAwesomeIcon icon={faChevronDown} className="text-[9px] ml-1.5 opacity-50" />
									)}
								</Link>

								{/* Dropdown Menu */}
								{hoveredCategory === category.id && category.subcategories?.length > 0 && (
									<div className="absolute left-0 top-full w-56 bg-white shadow-xl border border-stone-100 rounded-b-sm py-3 z-50 animate-in fade-in slide-in-from-top-1 duration-200">
										{category.subcategories.map((sub) => (
											<Link
												key={sub.id}
												to={sub.path || `/category/${sub.id}`}
												className="block px-6 py-2 text-stone-600 hover:bg-[#FDFBF7] hover:text-yellow-900 transition-colors normal-case tracking-normal"
											>
												{sub.name}
											</Link>
										))}
									</div>
								)}
							</div>
						))
					)}
				</div>

				{/* Seller CTA - Fixed width to prevent jumping */}
				{/* {isAuthenticated && (
					<div className="py-2 ml-4 flex-shrink-0">
						<Link to="/become-seller" className="flex items-center space-x-2 bg-yellow-950 text-yellow-50 px-4 py-2.5 rounded-sm hover:bg-stone-800 transition-all shadow-sm active:scale-95">
							<FontAwesomeIcon icon={faPlus} className="text-[10px]" />
							<span className="font-bold text-[11px] tracking-[0.15em]">Start Selling</span>
						</Link>
					</div>
				)} */}
			</div>
		</div>
	);
};

export default DesktopNavigation;